// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2x63t","cell":"ColumnAccessor_cell__3EUwQ","firstCellAccent":"ColumnAccessor_firstCellAccent__3NOGi"};